import { useEffect, useRef, useState } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"

function FormElement({ children, className, isSubmitting, isValid, name }) {
  const formRef = useRef(null)
  const [isFocused, setIsFocused] = useState(false)

  useEffect(() => {
    if (!isSubmitting) {
      setIsFocused(false)
    }
  }, [isSubmitting])

  useEffect(() => {
    if (isSubmitting && !isValid && !isFocused) {
      const invalidFields = formRef.current.querySelectorAll(".state-error input")
      if (invalidFields && invalidFields[0]) {
        setIsFocused(true)
        invalidFields[0].focus()
      }
    }
  }, [isSubmitting, isValid, isFocused])

  const preventDefault = e => e.preventDefault()

  return (
    <form
      className={classNames("oj-form", className)}
      name={name}
      onSubmit={preventDefault}
      ref={formRef}
    >
      {children}
    </form>
  )
}

FormElement.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isValid: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  name: PropTypes.string
}

export default FormElement
